
import { keyable } from "@/@types/global";
import { defineComponent, PropType } from "vue";

interface itemType {
  header: string;
  body: string;
}

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<Array<itemType>>,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTab: 1,
      prevTab: -1,
    };
  },
  watch: {
    currentTab(newVal, oldVal) {
      this.prevTab = oldVal;
    },
  },
  mounted() {},
});
